// window.addEventListener('scroll', () => {
//   const textElements = document.querySelectorAll('.scroll-text');

//   textElements.forEach((textElement) => {
//     const elementTop = textElement.getBoundingClientRect().top;
//     const windowHeight = window.innerHeight;

//     if (elementTop < windowHeight) {
//       textElement.classList.add('animated');
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // Helper function to interpolate between two hex colors
  function interpolateColor(color1, color2, factor) {
    const c1 = parseInt(color1.slice(1), 16);
    const c2 = parseInt(color2.slice(1), 16);

    const r1 = (c1 >> 16) & 0xff;
    const g1 = (c1 >> 8) & 0xff;
    const b1 = c1 & 0xff;

    const r2 = (c2 >> 16) & 0xff;
    const g2 = (c2 >> 8) & 0xff;
    const b2 = c2 & 0xff;

    const r = Math.round(r1 + (r2 - r1) * factor);
    const g = Math.round(g1 + (g2 - g1) * factor);
    const b = Math.round(b1 + (b2 - b1) * factor);

    return `rgb(${r}, ${g}, ${b})`;
  }

  function handleScrollAnimation() {
    const sections = document.querySelectorAll(".shopify-section");

    // Initial setup
    sections.forEach((section) => {
      const scrollText = section.querySelector(".scroll-text");
      const hborderText = section.querySelector(".hborderText");
      const hborderTextBottom = section.querySelector(".hborderTextBottom");
      if (scrollText) {
        scrollText.style.transform = "translateX(0)";
        scrollText.style.webkitTextStroke = "1.25px #D9C3D7"; // Initial outline
      }
      if (hborderText) {
        hborderText.style.transform = "translateX(0)";
        hborderText.style.webkitTextStroke = "3px #fff"; // Initial outline
      }
      if (hborderTextBottom) {
        hborderTextBottom.style.transform = "translateX(0)";
        hborderTextBottom.style.webkitTextStroke = "3px #fff"; // Initial outline
      }
    });

    window.addEventListener("scroll", () => {
      sections.forEach((section) => {
        const scrollText = section.querySelector(".scroll-text");
         const hborderText = section.querySelector(".hborderText");
        const hborderTextBottom = section.querySelector(".hborderTextBottom");

        if (scrollText) {
          const rect = section.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          if (rect.top < windowHeight && rect.bottom > 0) {
            // Progress of scroll through section
            const progress = Math.min(
              1,
              Math.max(0, (windowHeight - rect.top) / (rect.height + windowHeight))
            );

            // Horizontal movement
            const translateX = progress * 50;
            if (scrollText.classList.contains("left-side-text")) {
              scrollText.style.transform = `translateX(${translateX}%)`;
            } else if (scrollText.classList.contains("right-side-text")) {
              scrollText.style.transform = `translateX(-${translateX}%)`;
            }

            // Outline color transition
            const startColor = "#D9C3D7";
            const endColor = "#C7376E";
            const newColor = interpolateColor(startColor, endColor, progress);
            scrollText.style.webkitTextStroke = `1.25px ${newColor}`;
          }
        }

        if (hborderText) {
          const rect = section.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          if (rect.top < windowHeight && rect.bottom > 0) {
            // Progress of scroll through section
            const progress = Math.min(
              1,
              Math.max(0, (windowHeight - rect.top) / (rect.height + windowHeight))
            );

            // Horizontal movement
            const translateX = progress * 50;
            if (hborderText.classList.contains("left-side-text")) {
              hborderText.style.transform = `translateX(${translateX}%)`;
            } else if (hborderText.classList.contains("right-side-text")) {
              hborderText.style.transform = `translateX(-${translateX}%)`;
            }

            // Outline color transition
            const startColor = "#fff";
            const endColor = "#fff";
            hborderText.style.webkitTextStroke = `3px ${startColor}`;
          }
        }

        if (hborderTextBottom) {
          const rect = section.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          if (rect.top < windowHeight && rect.bottom > 0) {
            // Progress of scroll through section
            const progress = Math.min(
              1,
              Math.max(0, (windowHeight - rect.top) / (rect.height + windowHeight))
            );

            // Horizontal movement
            const translateX = progress * 50;
            if (hborderTextBottom.classList.contains("left-side-text")) {
              hborderTextBottom.style.transform = `translateX(${translateX}%)`;
            } else if (hborderTextBottom.classList.contains("right-side-text")) {
              hborderTextBottom.style.transform = `translateX(-${translateX}%)`;
            }

            // Outline color transition
            const startColor = "#fff";
            const endColor = "#fff";
            hborderTextBottom.style.webkitTextStroke = `3px ${startColor}`;
          }
        }
      });
    });

    // Trigger on load
    window.dispatchEvent(new Event("scroll"));
  }

  handleScrollAnimation();
});




// Show first highlight text (Our Story Page)
// if(jQuery('.template-page-our-story').length > 0){
//   jQuery('main .mainCollection:first-child .scroll-text').addClass('animated');
// }  

// Product Detail Page Accordion
jQuery('.card-header').click(function() {
  let card = jQuery(this).closest('.card');
  // let cardBody = card.find('.card-body');
  let arrowDown = jQuery(this).find('.accordion-arrow-down');
  let arrowUp = jQuery(this).find('.accordion-arrow-up');

  // Toggle the active class to show/hide the body
  // card.toggleClass('active');

  // Show the up arrow and hide the down arrow when the card is active
  if (card.hasClass('active')) {
    card.removeClass('active');
    arrowUp.show();
    arrowDown.hide();
  } else {
    jQuery('.card').removeClass('active');
    card.addClass('active');
    arrowUp.hide();
    arrowDown.show();
  }
});

//jQuery(".collection-hero__title").html("Collections");

